import { type TextFieldProps } from '@ui/atoms/text-field/textfield'
import { navigate } from 'gatsby'
import React, { type FC, useCallback } from 'react'

import { SearchField } from '../search/search-field'

export const FaqSearchbar: FC = () => {
  const onKeyDown: TextFieldProps['onKeyDown'] = useCallback((event) => {
    // @ts-expect-error
    const { value } = event.target
    if (event.key === 'Enter' && value.length > 0) {
      navigate(`/faq/recherche?term=${value}`)
    }
  }, [])

  return <SearchField onKeyDown={onKeyDown} />
}
